module.exports = __webpack_public_path__ + "media/images/business/mv-results-0755406712c8f9ff8e8fc510b1d29f57.svg";